import bankAccounts from "../consts/banks.json";
import Countdown from "react-countdown";
import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import config from "../consts/config.json";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import jphavale from "../wintogo.png";

const Spinner = () => (
  <div
    className="box-backbone flex-align-center flex-justify-center"
    style={{
      background: "#c5c5c5c7",
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
    }}
  >
    <div class="spinner"></div>
  </div>
);

const EmptyBankBox = () => (
  <div
    className="box-backbone flex-align-center flex-justify-center"
    style={{
      background: "#c5c5c5c7",
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
    }}
  ></div>
);

function goBackOrClose() {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.close();
  }
}

function userNameEncoder(name) {
  try {
    return name?.replace(/_/g, " ");
  } catch (e) {
    return name;
  }
}

function scrollDown() {
  window.scrollTo(0, document.body.scrollHeight);
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    window.scrollTo(0, document.body.scrollHeight);
  }
}

const urlParams = new URLSearchParams(window.location.search);
const hashed = urlParams.get("hashed");
const nameSurname = userNameEncoder(urlParams.get("name"));
const param_amount = urlParams.get("amount");

function App() {
  const [datenow, setDatenow] = useState(Date.now());
  const [amount, setAmount] = useState(param_amount);
  const [bankName, setBankName] = useState(bankAccounts.bankAccounts[0]);
  const [bankAccount, setBankAccount] = useState(false);
  const [isBankFormDisabled, setIsBankFormDisabled] = useState(false);
  const [isBankResponseLoading, setIsBankResponseLoading] = useState(false);
  const [showDepositStatusBox, setDepositRequested] = useState(false);
  const [isDepositStatusResponseLoading, setIsDepositStatusResponseLoading] =
    useState(false);
  const [transactionStatus, setTransactionStatus] = useState("pending");
  const [transactionStatusButtonEnabled, setTransactionStatusButtonEnabled] =
    useState(false);
  const [ip, setIP] = useState("");
  const [apiUrl, setApiUrl] = useState("make-deposit-request");

  const getTransactionStatus = async () => {
    setIsDepositStatusResponseLoading(true);
    setTimeout(() => {
      const req = axios
        .get(process.env.REACT_APP_API_URL + "transaction-status", {
          params: {
            hashed: hashed,
          },
        })
        .catch(() => {
          setIsDepositStatusResponseLoading(false);
          return null;
        })
        .then((req) => {
          setTransactionStatus(req?.data?.status);
          setIsDepositStatusResponseLoading(false);
        });
    }, 2000);
  };

  const getIpAddress = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIP(res.data.IPv4);
  };

  useEffect(() => {
    getIpAddress();
  }, []);

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    toast("✅ Kopyalandı");
  };

  const getBankAccount = async () => {
    if (!amount) {
      return toast("❌ Lütfen Miktar Giriniz");
    }

    if (!bankName) {
      return toast("❌ Lütfen Bir Banka Seçiniz");
    }

    setIsBankFormDisabled(true);
    setIsBankResponseLoading(true);

    let req;
    try {
      req = await axios.get(process.env.REACT_APP_API_URL + "available-banks", {
        params: {
          hashed,
          bankName,
          amount,
        },
      });
    } catch (error) {
      setIsBankFormDisabled(false);
      setIsBankResponseLoading(false);
      if (error?.response?.data?.status === "fail") {
        toast(error?.response?.data?.message);
      } else if (error?.response?.data?.error) {
        toast("❌ " + error?.response?.data?.error);
      } else {
        toast("❌ Bir hata oluştu. Lütfen tekrar deneyiniz.");
      }
      return false;
    }

    setIsBankResponseLoading(false);

    if (!req || !req.data) {
      toast(
        "❌ Miktara veya banka tipine göre uygun hesap bulunamadı. \n⚙️ 7/24 Fast seçerek tekrar deneyebilirsiniz.",
      );
      setBankAccount(false);
      setIsBankFormDisabled(false);
      return false;
    }

    const website = req.data?.website;
    if (website?.username === "megapayz") {
      setApiUrl("/MegaPayz/banktransfer/submitDeposit");
    }

    const fetchedBank = req.data?.getBank;

    if (!fetchedBank) {
      toast(
        req.data?.message ||
          "❌ Miktara veya banka tipine göre uygun hesap bulunamadı. \n⚙️ 7/24 Fast seçerek tekrar deneyebilirsiniz.",
      );
      setBankAccount(false);
      setIsBankFormDisabled(false);
      return false;
    }

    setBankAccount(fetchedBank);
    setIsBankFormDisabled(true);
    scrollDown();
    return fetchedBank;
  };

  const makeDepositRequest = async () => {
    if (bankAccount && bankAccount?.noDeposit == true) {
      return setDepositRequested(true);
    }
    setIsBankResponseLoading(true);
    try {
      const req = await axios.post(process.env.REACT_APP_API_URL + apiUrl, {
        hashed: hashed,
        amount: amount || 0,
        bankAccountId: bankAccount?._id || "",
        ipaddress: ip,
      });
      if (req.data.timeout) {
        return toast(
          "❌ Hata: Mevcut bekleyen yatırımınız bulunmaktadır. \nLütfen sonuçlanmasını bekleyiniz veya bir süre sonra dakika sonra tekrar deneyin",
        );
      }
      if (req.data.message == "Transaction id already exists") {
        return toast(
          "Bu işlem daha önce yapılmıştır. Lütfen yeni bir işlem ile tekrar deneyiniz",
        );
      }
      if (req?.data?.status === "fail") {
        toast(req?.data?.message);
      }

      setDepositRequested(true);
    } catch (e) {
      toast("HATA OLDU");
    } finally {
      setIsBankResponseLoading(false);
    }
  };

  const CountDownRenderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      window.location.href = "about:blank";
    } else {
      return (
        <span>
          {minutes < 10 ? "0" + minutes : minutes}:
          {seconds < 10 ? "0" + seconds : seconds}
        </span>
      );
    }
  };

  const TransactionStatusButtonCountDownRenderer = ({
    hours,
    minutes,
    seconds,
    completed,
  }) => {
    if (completed) {
      // setTransactionStatusButtonEnabled(true)
    } else {
      return (
        <span>
          {minutes < 10 ? "0" + minutes : minutes}:
          {seconds < 10 ? "0" + seconds : seconds}
        </span>
      );
    }
  };

  return (
    <div class="container mt-4 p-2">
      <style jsx>{`
        .warning-card {
          margin-top: 24px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 24px;
          margin-bottom: 24px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05);
          border-left: 4px solid #ef4444;
        }
        @media (max-width: 576px) {
          .warning-card {
            margin-left: 0;
            margin-right: 0;
            border-radius: 16px;
          }
        }
        @media (max-width: 768px) {
          .warning-card {
            padding: 16px;
            margin: 0 0 16px 0;
          }
        }
      `}</style>
      <div
        className="row box-backbone d-flex flex-row pt-3 pb-3 justify-content-between"
        style={{ minHeight: 100 }}
      >
        <div className="col-lg-3 col-md-6 d-flex flex-justify-between flex-align-between card-title-h1 fw-semibold color-blue ">
          {!showDepositStatusBox && (
            <>
              <i
                class="fa-solid fa-clock mr-3 color-blue"
                style={{ fontSize: 50 }}
              ></i>{" "}
              <Countdown
                date={datenow + 300000 * 2}
                renderer={CountDownRenderer}
              />
            </>
          )}
        </div>

        <div className="col-lg-3 col-md-6 d-flex flex-justify-between flex-align-between card-title-h1 fw-bold">
          Havale ile ödeme
        </div>
        <div className="col-lg-3 col-md-6 d-flex flex-justify-between flex-align-between card-title-h1 fw-bold">
          <img
            src={jphavale}
            alt="Logo 2"
            style={{ width: "auto", height: "100px" }}
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm box-backbone flex-justify-center card-info pl-3">
          <b>BİLGİ: </b> Lütfen kendinize ait hesap ile yatırım yapınız. Yatırım
          yapmak için <b>10 dakikanız </b> vardır.
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm box-backbone flex-justify-center card-danger pl-3">
          <b>UYARI: </b>Lütfen açıklama kısmını <b>Boş</b> bırakınız
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md box-backbone pt-3 pb-4 mt-2 mr-md-2">
          <div className="card-title-h3 fw-semibold ml-2">
            Gönderen Bilgileri
          </div>

          <div className="row ml-2 mt-2 mr-2">
            <p className="mt-2">Ad Soyad</p>
          </div>

          <div className="row ml-2 mr-2">
            <input
              type="text"
              className="form-control"
              disabled
              value={nameSurname}
            ></input>
          </div>

          <div className="row ml-2 mt-2 mr-2">
            <p className="mt-2">Yatırım Miktarı</p>
          </div>

          <div className="row ml-2 mr-2">
            <input
              type="number"
              className="form-control"
              value={amount}
              disabled={isBankFormDisabled}
              onChange={(e) => setAmount(e.target.value)}
              required
            ></input>
          </div>

          <div className="row ml-2 mt-2 mr-2">
            <p className="mt-2">Banka Tercihi</p>
          </div>

          <div className="row ml-2 mt-1 mr-2">
            <select
              type="text"
              className="form-control"
              defaultValue="100"
              required
              disabled={isBankFormDisabled}
              onChange={(e) => setBankName(e.target.value)}
            >
              {bankAccounts.bankAccounts.map((e) => (
                <option>{e}</option>
              ))}
            </select>
          </div>

          <div className="row ml-2 mt-4 mr-2">
            {!isBankFormDisabled && (
              <button
                type="button"
                class="btn btn-primary w-100 mx-auto btn-lg fw-semibold"
                disabled={isBankFormDisabled}
                onClick={() => getBankAccount()}
              >
                Hesap Getir
              </button>
            )}
          </div>
        </div>

        {!showDepositStatusBox && (
          <div className="col-md box-backbone pt-3 pb-4 mt-2 mr-md-2">
            {isBankResponseLoading && <Spinner />}
            {!bankAccount && <EmptyBankBox />}
            <div className="card-title-h3 fw-semibold ml-2">
              Alıcı Hesap Bilgileri
            </div>

            <div className="row ml-2 mt-2 mr-2">
              <p className="mt-2">Alıcı Ad Soyad</p>
            </div>

            <div className="row ml-2 mr-2">
              <label class="sr-only" for="inlineFormInputGroup"></label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    onClick={() => copyText(bankAccount?.nameSurname)}
                  >
                    <i class="fa fa-clone" aria-hidden="true"></i>
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="inlineFormInputGroup"
                  value={bankAccount?.nameSurname}
                  disabled
                />
              </div>
            </div>

            <div className="row ml-2 mt-2 mr-2">
              <p className="mt-2">Hesap Numarası / IBAN</p>
            </div>
            <div className="row ml-2 mr-2">
              <label class="sr-only" for="inlineFormInputGroup">
                Username
              </label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    onClick={() => copyText(bankAccount?.iban)}
                  >
                    <i class="fa fa-clone" aria-hidden="true"></i>
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="inlineFormInputGroup"
                  value={bankAccount?.iban}
                  disabled
                />
              </div>
            </div>

            <div className="row ml-2 mt-1 mr-2">
              <p className="mt-1">Açıklama</p>
            </div>

            <div className="row ml-2 mr-2">
              <input
                type="text"
                className="form-control"
                disabled
                value={`${bankAccount?.description || ""}`}
              ></input>
            </div>

            <div className="row ml-2 mt-4 mr-2">
              {
                <button
                  type="button"
                  class="btn btn-danger w-100 mx-auto btn-lg fw-semibold"
                  onClick={() =>
                    confirmAlert({
                      title: "Yatırım Talebi",
                      message:
                        "Yatırım talebi vermek üzeresiniz. Yatırımı ilgili hesaba gönderdiniz mi ?",
                      buttons: [
                        {
                          label: "Evet",
                          onClick: () => makeDepositRequest(),
                        },
                        {
                          label: "Hayır",
                        },
                      ],
                    })
                  }
                >
                  Yatırımı Yaptım
                </button>
              }
            </div>
          </div>
        )}

        {showDepositStatusBox && (
          <div className="col-md box-backbone pt-3 pb-4 mt-2 mr-md-2 flex-align-center flex-justify-center">
            {isDepositStatusResponseLoading && <Spinner />}
            <div className="radius d-flex flex-justify-center card-success p-2 w-100">
              ✅ Yatırım talebi başarılı bir şekilde iletildi.
            </div>

            <div className="radius d-flex flex-justify-center card-info p-2 w-100 mt-2">
              <b>Yatırım Durumu:</b>{" "}
              {transactionStatus === "pending"
                ? "Beklemede"
                : transactionStatus === "success"
                  ? "Başarılı / Onaylandı"
                  : transactionStatus === "fail"
                    ? "Reddedildi"
                    : "Hata Oluştu"}
            </div>

            <button
              type="button"
              onClick={() => goBackOrClose()}
              class="btn btn-primary w-100 mx-auto mt-5 fw-semibold"
            >
              Siteye Git
            </button>

            <button
              type="button"
              class="btn btn-warning w-100 mx-auto mt-1 fw-semibold"
              style={{ color: "#444" }}
              onClick={() => getTransactionStatus()}
            >
              Yatırım Durumunu Sorgula
            </button>
          </div>
        )}
      </div>
      <Toaster />

      <div
        className="row box-backbone d-flex flex-justify-center flex-align-center flex-row mt-3 pt-3 pb-3"
        style={{ minHeight: 100 }}
      >
        <marquee>
          <div
            className="d-flex flex-justify-center flex-align-center"
            style={{ minHeight: 100 }}
          >
            <div className="mr-4">
              <img
                className="bank-image mb-1 mr-3"
                src="img/banks/akbank.png"
              />
            </div>
            <div className="mr-4">
              <img
                className="bank-image mb-1 mr-3"
                src="img/banks/denizbank.webp"
              />
            </div>
            <div className="mr-4">
              <img
                className="bank-image mb-1 mr-3"
                src="img/banks/enpara.png"
              />
            </div>
            <div className="mr-4">
              <img
                className="bank-image mb-1 mr-3"
                src="img/banks/garanti.png"
              />
            </div>
            <div className="mr-4">
              <img className="bank-image mb-1 mr-3" src="img/banks/ing.png" />
            </div>
            <div className="mr-4">
              <img
                className="bank-image mb-1 mr-3"
                src="img/banks/isbank.png"
              />
            </div>
            <div className="mr-4">
              <img
                className="bank-image mb-1 mr-3"
                src="img/banks/yapikredi.png"
              />
            </div>
          </div>
        </marquee>
      </div>
    </div>
  );
}

export default App;
